import { templateSnapshot } from "types/Template";

export const getSnapshotId = (providerId: number, cardId: number): number => {
  switch (providerId) {
    case 1:
      if (cardId === 2) return templateSnapshot.physicianOrganizational;
      return templateSnapshot.physicianIndividual;
    case 2:
      return templateSnapshot.physicianIndividual;
    case 3:
      return templateSnapshot.locationClinic;
    case 4:
      return templateSnapshot.taxonomy;
    default:
      return templateSnapshot.physicianIndividual;
  };
};